import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile, TokenizedPaymentCard } from '@/models';

@Component({
  name: 'CmgGiftCardQrModal',
})
export default class CmgGiftCardQrModal extends Vue {
  get balance(): number {
    if (this.giftCard) {
      const giftCardBalance = this.$appStore.state.customer.wallet.giftCardBalances[this.giftCard.tokenizedAccountNumber];
      return giftCardBalance;
    }

    return 0;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get isCustomerStudent(): boolean {
      return this.$appStore.getters.isActiveStudent;
  }

  get chipotleUMobileScanBackground(): string {
      return this.$appStore.state.cms.images.loyalty.chipotleUMobileScanBackground.default;
  }

  get giftCard(): TokenizedPaymentCard | undefined {
    return this.$appStore.state.customer.wallet.paymentCards.find(card => card.isGiftCard === true);
  }

  get isLoyaltyMember(): boolean {
    return this.$services.loyalty.isLoyaltyEligible(this.customer) && this.$services.loyalty.isEnrolledInLoyalty(this.customer);
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.giftCardQr.visible;
  }

  onClose() {
    this.$services.ui.setModalVisibility('giftCardQr', false);
  }
}
